import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems

/**
 * @module stickyAnchorLinksNavigationOnScroll
 *
 * To debugging the scrolling and elements position,
 * uncomment the funciton ".addIndicators()" in the code base to show the Indicators in frontend
 * for more infomation please visit
 * http://scrollmagic.io/examples/basic/scene_manipulation.htmlhttps://greensock.com/docs
 */
(function stickyAnchorLinksNavigationOnScroll() {

    function stickyAnchorLinksNavigationOnScroll($dom) {
        /**
         * // local object availability
         * @type {stickyAnchorLinksNavigationOnScroll}
         * @private
         */
        var _this = this;

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.triggerHookNum = 0; // 'onLeave','onCenter','onEnter', OR the number from  0.00 to 1.00
            this.headerHeight = $("[data-html-element='header']")[0].clientHeight;
            this.anchorLinksNavigationHeight = $dom[0].clientHeight;
            this.offset = '-' + _this.headerHeight + 'px';
            this.scrollOffset = 16;
            this.$navigationLinkItemElements = $dom.find("[data-element='tour-anchor-links-navigation-link-item']");

            _this.stickyOnScrollWhenMeetHeader();
            _this.anchorLinkSmoothScroll();

            // scroll to id if user called page with hash
            if (window.location.href.indexOf('#') > -1) {
                var isolatedCurrentHash = window.location.href.substr(window.location.href.indexOf('#'));
                // wait some time until default user scroll to id is done
                setTimeout(function () {
                    _this.scrollToHash(decodeURI(isolatedCurrentHash));
                }, 100);
            }
        };


        /**
         * @method stickyOnScroll
         * @returns {undefined}
         */
        this.stickyOnScrollWhenMeetHeader = function () {
            var pin = new ScrollMagic.Scene({
                triggerElement: $dom[0],
                triggerHook: _this.triggerHookNum,
                offset: _this.offset
            }).setPin($dom[0])
            /** to debugging the scrolling and element position, uncomment the line below to show the Indicators in frontend */
            // .addIndicators()
                .addTo(new ScrollMagic.Controller());
        };


        /**
         * @method anchorLinkSmoothScroll
         * @returns {undefined}
         */
        this.anchorLinkSmoothScroll = function () {
            $(document).on('click', 'a[href^="#"]', function (event) {
                event.preventDefault();
                var href = $(this).attr('href');
                window.location.hash = _this.scrollToHash(href);
            });
        };


        /**
         * Scroll to give hash
         * @param hash
         * @returns {string} Hash as id(without #)
         */
        this.scrollToHash = function (hash) {
            var firstNavigationLinkItem = _this.$navigationLinkItemElements[0];

            if ($(hash).length === 0) {
                throw new Error('Given hash was not found: ' + hash);
            }

            // Without scrollOffset when first item is active
            if (hash === $(firstNavigationLinkItem).attr('href')) {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - _this.headerHeight - _this.anchorLinksNavigationHeight
                }, 300);
                // With scrollOffset
            } else {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - _this.headerHeight - _this.anchorLinksNavigationHeight - _this.scrollOffset
                }, 300);
            }

            _this.$navigationLinkItemElements.removeClass('active');
            // set active state in navigation
            $dom.find("a[href='" + hash + "']").addClass('active');
            var cleanHash = hash.substr(hash.indexOf('#') + 1);
            return cleanHash;
        };


        /**
         * initialize call
         */
        _this.init();
    }


    // define the global scope
    if (!window.Bikealpin) {
        window.Bikealpin = {};
    }

    window.Bikealpin.stickyAnchorLinksNavigationOnScroll = stickyAnchorLinksNavigationOnScroll;
})();


$(document).ready(function () {
    var $tourAnchorLinksNavigationElement = $("[data-element='tour-anchor-links-navigation']");
    if ($tourAnchorLinksNavigationElement.length >= 1) {
        new window.Bikealpin.stickyAnchorLinksNavigationOnScroll($tourAnchorLinksNavigationElement);
    }
});
